// extracted by mini-css-extract-plugin
export var content = "_pi-1";
export var noScroll = "_pi-3";
export var paper = "_pi-0";
export var scrollable = "_pi-2";